/**************************************************
 * Nombre:       Formulario_Producto_Variante
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import IngresoTexto from "../../../Modulo_formularios/Componentes/IngresoTexto";
import {useIngresarObjeto} from "../../../Modulo_formularios/Hooks/useIngresarObjeto";
import Formulario_Producto_Variante_Variante from "./Formulario_Producto_Variante_Variante";
import Tarjetas_Producto_Variante from "../../Tarjeta/Tarjetas_Producto_Variante";

const Formulario_Producto_Variante = ({...props}) => {
    const {IngresarObjeto} = useIngresarObjeto({
        props: props,
        nombre: 'Agregar Variante',
        dato: 'variantes',
        Formulario: Formulario_Producto_Variante_Variante,
        Tarjeta: Tarjetas_Producto_Variante
    })


    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={12}>
                    <IngresoTexto nombre={'Nombre del producto'}
                                  dato={'nombre'} {...props}
                                  editable={false}
                                  requerido={'El Nombre es requerido'}
                    />
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography>Variantes y precios</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <IngresarObjeto/>
                </Grid>

            </Grid>

        </form>

    )

}
export default Formulario_Producto_Variante